export const getAssistantSchedulerAction = (action) => {
  if (!action || action.type !== 'open_scheduler' || !['lesson', 'solo'].includes(action.flightType)
    || typeof action.preferredDate !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(action.preferredDate)
    || !(action.locationId === null || (Number.isInteger(action.locationId) && action.locationId > 0))) return null;
  const date = new Date(`${action.preferredDate}T00:00:00Z`);
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== action.preferredDate) return null;
  return { type: 'open_scheduler', preferredDate: action.preferredDate, flightType: action.flightType, locationId: action.locationId };
};

export const sendAssistantMessage = async (request, text, sessionId, signal) => {
  const message = text.trim();
  if (!message || message.length > 2000) throw new Error('Enter a message between 1 and 2,000 characters.');
  const response = await request('/assistant/message', {
    method: 'POST', headers: { 'Content-Type': 'text/plain', 'session-id': sessionId }, body: message, signal
  });
  let data;
  try { data = await response.json(); }
  catch { throw new Error(`Assistant returned an invalid response (HTTP ${response.status}).`); }
  if (!response.ok) throw new Error(data?.error || `Unable to contact the assistant (HTTP ${response.status}).`);
  if (typeof data?.response !== 'string' || !data.response.trim()) throw new Error('The assistant returned an empty response.');
  return { response: data.response, action: getAssistantSchedulerAction(data.action) };
};